import { Component, OnInit } from '@angular/core';
import { IDropdownSettings} from 'ng-multiselect-dropdown';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/_shared/services/user.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { first } from 'rxjs/operators';
import {Role, User} from 'src/app/users/models/user.model';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { JSON} from '../../models/json-response';
import { Subject } from 'rxjs';
import { RoleService } from 'src/app/users/services/role.service';


interface RoleOption { value: any; label: any; disabled: boolean; }
@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss']
})
export class CreateUserComponent implements OnInit {

  public readonly MAX_SIZE: number = 3;
  public totalItems = 0;
  public PAGE = 1;
  userForm!: FormGroup;
  roleForm!: FormGroup;
  selectedRole!: any;
  loading!: boolean;
  roleOption!: RoleOption;
  roleSelect!: Array<any>;
  is_active: boolean = false
  is_active_bool: boolean = true;
  loadingSpinner = false;
  user!:User;
    allroles: Role[] = [];
  
  roles = [
    new Role(1,true,"User"),
    new Role(2,true,"Admin"),
    new Role(3,true,"Regional Manager"),
    new Role(4,true,"Reporter"),
  ]
  
  selected : any= []
  
  dropdownSettings = {};
  constructor(
  private userService: UserService,
  private toastr: ToastrService,
  private toastService: ToastrService,
  private _router: Router,
  private _fb: FormBuilder,
  private userFormBuilder: FormBuilder,
  private roleFormBuilder: FormBuilder,
  public bsModalRef: BsModalRef,
  private _roleService: RoleService
  ) {
  this.roleSelect = [];
  
  this.dropdownSettings = {
  singleSelection: false,
  idField: 'id',
  textField: 'name',
  selectAllText: 'Select All',
  unSelectAllText: 'UnSelect All',
  itemsShowLimit: 3,
  // allowSearchFilter: true
  } as IDropdownSettings;
  
  this.userForm = this.userFormBuilder.group({
  email: ['', Validators.compose(
  [
  Validators.required,
  Validators.email,
  Validators.pattern(this.userService.emailPattern),
  Validators.maxLength(50)])
  ],
  first_name: ['', Validators.compose([
  Validators.required,
  Validators.pattern(this.userService.namePattern), Validators.maxLength(50)])],
  other_name: ['', Validators.compose([Validators.required,
    Validators.pattern(this.userService.namePattern), Validators.maxLength(50)])],
    last_name: ['', Validators.compose([Validators.required,
      Validators.pattern(this.userService.namePattern), Validators.maxLength(50)])],
  is_active: [false, Validators.compose([Validators.required])],
  
  selectRole: [null, Validators.required],
  'roles': this._fb.array([this.selectedRole])
  });
  this.roleForm = this.roleFormBuilder.group({
  priviledges: new FormArray([])
  });
  }
  
  ngOnInit(): void {
  this._roleService.getRoles().subscribe(
  data => {
    let response: JSON = data as unknown as JSON;
  
    let rolesfromapi = response.data as unknown as Role[];
    this.allroles = rolesfromapi
  })}                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         
    
  onItemSelect(item: any) {
  // this.roles.push(item)
  console.log('onItemSelect', item)
  ;
  }
  
  onSelectAll(item: any) {
  // this.roles.push(items)
  console.log('onSelectAll', item);
  }
  
  onItemDeSelect(item: any) {
    console.log('onItemDeSelect', item);
  }
  
  onSubmit() {
  console.log("have been clicked")
  if (this.userForm.invalid){
  return;}
  
  const userData = {
  first_name: this.userForm.controls.first_name.value,
  other_name: this.userForm.controls.other_name.value,
  last_name: this.userForm.controls.last_name.value,
  email_address: this.userForm.controls.email.value,
  is_active:   this.is_active_bool,
  
  
  
  roles: this.userForm.value.selectRole,
  };
  console.log('is active detaols',this.userForm.controls.is_active.value);
  
  console.log(userData);
  
  console.log( this.user)
    this.loading = true;
    this.userService.createUser(userData).pipe(first()).subscribe(data => {
      console.log("user created successerr 2",data.status)
      if(data.status == 200 || data.status == 201){
    this.toastService.success("User Created successfully");
  this.loading = false;
  this.closeCreateUserModal('created')
  }else {
    this.userService.create(userData).subscribe(() => {
    this.toastr.success('User created successfully', 'Success');
      this._router.navigate(['/users']);
    this.userForm.reset();
    this.loading = false;
    }, (error: HttpErrorResponse) => {
    this.loading = false;
    const status = error.status;
    if(status != 0 && status != 401 && status != 500) {
    this.toastr.error(error.error.api_code_description, 'Failed');
    }
    })
    }
  console.log(data.status);
  }
  )}
  newUser(newUser: any) {
  throw new Error('Method not implemented.');
  }
  public get rolesFormArray(): FormArray {
  return (this.roleForm.get('roleForm') as FormArray);
  }
  
  getSelectedPartner(event: any) {
  if(event == null){
  return;
  }
  
  }
  closeCreateUserModal(event: string) {
  this.bsModalRef!.hide();
  }
  
  onActive(ev: any) {
    let status = ev.target.value;
    this.is_active_bool = status == "0"? false: true;
    console.log(this.is_active_bool)
  }
  
  // Form validation methods
  public isInValid(inputName: string, error: string, form: FormGroup): boolean {
  return form.controls[inputName].hasError(error);
  }
  public isTouched(inputName: string, form: FormGroup): boolean {
  return form.controls[inputName].touched;
  }
  public get isEmailInvalid(): boolean {
  return this.isInValid('email', 'required', this.userForm) && this.isTouched('email', this.userForm);
  }
  public get isEmailPatternInvalid(): boolean {
  return this.isInValid('email', 'email', this.userForm) && this.isTouched('email', this.userForm);
  }
  public get isEmailLengthInvalid(): boolean {
  return this.isInValid('email', 'maxlength', this.userForm) && this.isTouched('email', this.userForm);
  }
  // first name
  public get isFirstNameInvalid(): boolean {
  return this.isInValid('first_name', 'required', this.userForm) && this.isTouched('first_name', this.userForm);
  }
  public get isFirstNamePatternInvalid(): boolean {
  return this.isInValid('first_name', 'pattern', this.userForm) && this.isTouched('first_name', this.userForm);
  }
  public get isFirstNameLengthInvalid(): boolean {
  return this.isInValid('first_name', 'maxlength', this.userForm) && this.isTouched('first_name', this.userForm);
  }
  // last name
  public get isLastNameInvalid(): boolean {
  return this.isInValid('last_name', 'required', this.userForm) && this.isTouched('last_name', this.userForm);
  }
  public get isLastNamePatternInvalid(): boolean {
  return this.isInValid('last_name', 'pattern', this.userForm) && this.isTouched('last_name', this.userForm);
  }
  public get isLastNameLengthInvalid(): boolean {
  return this.isInValid('last_name', 'maxlength', this.userForm) && this.isTouched('last_name', this.userForm);
  }
  // last name
  public get isOtherNameInvalid(): boolean {
  return this.isInValid('other_name', 'required', this.userForm) && this.isTouched('other_name', this.userForm);
  }
  public get isOtherNamePatternInvalid(): boolean {
  return this.isInValid('other_name', 'pattern', this.userForm) && this.isTouched('other_name', this.userForm);
  }
  public get isOtherNameLengthInvalid(): boolean {
  return this.isInValid('other_name', 'maxlength', this.userForm) && this.isTouched('other_name', this.userForm);
  }
  //selectRole
  public get isSelectRoleInvalid(): boolean {
  return this.isInValid('other_name', 'required', this.userForm) && this.isTouched('other_name', this.userForm);
  }
  }
  
  